import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiselectObjectManagerComponentBase } from '../../../core/component/multiselect-object-manager/multiselect-object-manager.component';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { Article } from '../../model/article';
import { ArticleService } from '../../service/data/article.service';
import { ColumnDefinitionService } from '../../service/data/column-definition.service';
import { ArticleCommandHandlerResolver } from '../../service/command/article-command-handler-resolver.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { AdjustmentKind, AdjustmentKindToString } from '../../model/const/enums';
import ListViewColumn from '../../../core/model/list-view-column';
import { ColumnDefinition } from '../../../core/model/column-definition';

@Component({
    selector: 'app-article-manager',
    templateUrl: './article-manager.component.html',
    styleUrls: ['./../../../core/component/multiselect-object-manager/multiselect-object-manager.component.scss'],
    providers: [ArticleCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ArticleMultiSelectManagerComponent extends MultiselectObjectManagerComponentBase<Article> {
  adjustments = [
    { caption: 'ALL_TEXT', value: null },
    { caption: AdjustmentKindToString(AdjustmentKind.None), value: AdjustmentKind.None },
    { caption: AdjustmentKindToString(AdjustmentKind.Free), value: AdjustmentKind.Free },
    { caption: AdjustmentKindToString(AdjustmentKind.Negotiation), value: AdjustmentKind.Negotiation },
    { caption: AdjustmentKindToString(AdjustmentKind.Index), value: AdjustmentKind.Index },
    { caption: AdjustmentKindToString(AdjustmentKind.FixedPercentage), value: AdjustmentKind.FixedPercentage },
    { caption: AdjustmentKindToString(AdjustmentKind.FeeToBrf), value: AdjustmentKind.FeeToBrf },
  ];
  excelColumnDefinition: ColumnDefinition<Article>[] = [];
  excelContext = 'Article';
  excelFileName = 'Artiklar';
  selectedColumns: ListViewColumn<Article>[] = [];
  selectedArticleIds: string[] = [];
  private pendingSelectedColumns: ListViewColumn<Article>[] = [];
  private columnUpdateScheduled = false;
  constructor(
    columnDefinitionService: ColumnDefinitionService,
    private _dataService: ArticleService,
    dispatcher: CommandDispatcher,
    messageService: MessageService,
    navigationService: NavigationService,
    handlerResolver: ArticleCommandHandlerResolver
  ) {
    super(_dataService, dispatcher, handlerResolver, messageService, navigationService);
    this.columnDefinition = columnDefinitionService.create('Article');
    this.excelColumnDefinition = [...this.columnDefinition];
    this.title = 'ARTICLE_LIST.HEADER';
    this.preferencesKey = 'rent.article-manager.list';
    this.filterState = {};
  }

  get excelReady(): boolean {
    return this.selectedColumns.length > 0;
  }

  get selectedArticleCount(): number {
    return this.selectedArticleIds.length;
  }

  get allArticlesSelected(): boolean {
    return this.selectedArticleCount > 0 && this.selectedArticleCount === this.itemsSource?.length;
  }

  get totalArticles(): number {
    return this.itemsSource?.length ?? 0;
  }

  onColumnChange(columns: ListViewColumn<Article>[]): void {
    this.pendingSelectedColumns = columns.filter(column => column.selected);
    if (this.columnUpdateScheduled) return;

    this.columnUpdateScheduled = true;
    queueMicrotask(() => {
      this.columnUpdateScheduled = false;
      this.selectedColumns = this.pendingSelectedColumns;
    });
  }

  onSelectedArticlesChange(articles: Article[]): void {
    this.selectedArticleIds = articles.map(article => article.id);
  }

  onFilterChange(filterState: any): void {
    this.selectedArticleIds = [];
    super.onFilterChange(filterState);
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe(definition => {
        this.defaultFilters = definition.defaultFields;
        this.filterDefinition = [
          new FilterDefinitionItem(
            'ARTICLE.CAPTION',
            'captionContains',
            definition.captionContains,
            null,
            definition.selectedFields.includes('captionContains')
          ),
          new FilterDefinitionItem('ARTICLE.CODE', 'code', definition.code, null, definition.selectedFields.includes('code')),
          new FilterDefinitionItem(
            'ARTICLE.ADJUSTMENT',
            'adjustment',
            definition.adjustment,
            this.adjustments,
            definition.selectedFields.includes('adjustment')
          ),
        ];
      })
    );

    this.addEditDeleteCommands();
  }
}

function getAdjustments(): any[] {
  throw new Error('Function not implemented.');
}
